/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import Loader from "../../Components/Loader";
import { productActionCreators } from "../../services/Actions";
import ProductModal from "../Modal/AddProductModal";
import RenderHirePurchasePage from "../RenderHirePurchasePage";
import { RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit, FiPlus, FiTag, FiCalendar, FiAlignLeft } from "react-icons/fi";
import * as moment from "moment";
import { GetUserProfile } from "../../services/Actions/authActions";
import PromptModal from "../../AdminModel/Components/PromptModal";

function ProductCategory() {
  const dispatch = useDispatch();
  const {
    GetProductCategory,
    AddProductCategory,
    ResetProductResponse,
    DeleteCategory,
    EditProductCategory,
  } = bindActionCreators(productActionCreators, dispatch);

  const product = useSelector((state) => state?.product);
  const { category, response, isLoading } = product;

  const [openPromptModal, setPromptOpenModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [categoryFormData, setCategoryFormData] = useState({
    name: "",
    description: "",
  });
  const [categoryEditFormData, setCategoryEditFormData] = useState({
    name: "",
    description: "",
  });
  const [selectedEditData, setSelectedEditData] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategoryFormData({ ...categoryFormData, [name]: value });
  };

  const handleEditProductChange = (e) => {
    const { name, value } = e.target;
    setCategoryEditFormData({ ...categoryEditFormData, [name]: value });
  };

  const handleSubmitCategory = (e) => {
    e.preventDefault();
    if (!categoryFormData.name) return toast.error("Category name is required");
    AddProductCategory(categoryFormData);
    setOpenModal(false);
    setCategoryFormData({ name: "", description: "" });
  };

  const handleSubmitEditCategory = (e) => {
    e.preventDefault();
    EditProductCategory(selectedEditData?._id, categoryEditFormData);
    setOpenEditModal(false);
  };

  useEffect(() => {
    GetProductCategory();
    dispatch(GetUserProfile());
  }, []);

  useEffect(() => {
    if (selectedEditData) {
      setCategoryEditFormData({
        name: selectedEditData?.name || "",
        description: selectedEditData?.description || "",
      });
    }
  }, [selectedEditData]);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => {
        ResetProductResponse();
        GetProductCategory();
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetProductResponse(), 1500);
    }
  }, [response?.state]);

  return (
    <div className="bg-gray-50/50 min-h-screen">
      <RenderHirePurchasePage>
        {isLoading && <Loader />}

        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8 pt-4">
          <div>
            <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
              <FiTag className="text-indigo-600" /> Product Categories
            </h2>
            <p className="text-sm text-gray-500">
              Manage and organize your product groups
            </p>
          </div>
          <button
            type="button"
            className="flex items-center justify-center gap-2 px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl shadow-lg shadow-indigo-200 transition-all active:scale-95"
            onClick={() => setOpenModal(true)}
          >
            <FiPlus /> Add New Category
          </button>
        </div>

        {/* Table Section */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <table className="min-w-full divide-y divide-gray-100">
            <thead>
              <tr className="bg-gray-50/50">
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-400 uppercase tracking-widest">
                  Category Name
                </th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-400 uppercase tracking-widest">
                  Description
                </th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-400 uppercase tracking-widest">
                  Date Created
                </th>
                <th className="px-6 py-4 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {category?.map((cate, index) => (
                <tr
                  key={index}
                  className="hover:bg-indigo-50/30 transition-colors group"
                >
                  <td className="px-6 py-4">
                    <span className="text-sm font-bold text-gray-800 group-hover:text-indigo-600 transition-colors">
                      {cate?.name}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <p
                      className="text-sm text-gray-500 max-w-xs truncate"
                      title={cate?.description}
                    >
                      {cate?.description || (
                        <span className="italic opacity-50">
                          No description provided
                        </span>
                      )}
                    </p>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <FiCalendar className="text-gray-300" />
                      {moment(cate?.created_at).format("MMM Do, YYYY")}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right space-x-2">
                    <button
                      className="p-2 text-gray-400 hover:text-green-600 hover:bg-green-50 rounded-lg transition-all"
                      onClick={() => {
                        setSelectedEditData(cate);
                        setOpenEditModal(true);
                      }}
                    >
                      <FiEdit size={18} />
                    </button>
                    <button
                      className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all"
                      onClick={() => {
                        setSelectedEditData(cate);
                        setPromptOpenModal(true);
                      }}
                    >
                      <RiDeleteBin2Line size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Add Modal */}
        {openModal && (
          <ProductModal
            closeModal={setOpenModal}
            width="450px"
            title={"New Category"}
          >
            <form onSubmit={handleSubmitCategory} className="p-2">
              <div className="space-y-4">
                <div>
                  <label className="block mb-2 text-xs font-bold text-gray-500 uppercase">
                    Category Name
                  </label>
                  <div className="relative">
                    <FiTag className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                    <input
                      type="text"
                      name="name"
                      className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
                      placeholder="e.g. Home Appliances"
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div>
                  <label className="block mb-2 text-xs font-bold text-gray-500 uppercase">
                    Description
                  </label>
                  <textarea
                    name="description"
                    rows="4"
                    className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
                    placeholder="Briefly describe what items belong here..."
                    onChange={handleChange}
                  ></textarea>
                </div>
                <div className="flex gap-3 pt-4 border-t border-gray-100">
                  <button
                    type="submit"
                    className="flex-1 py-3 bg-indigo-600 text-white font-bold rounded-xl hover:bg-indigo-700 transition-all shadow-md shadow-indigo-100"
                  >
                    Save Category
                  </button>
                  <button
                    type="button"
                    onClick={() => setOpenModal(false)}
                    className="flex-1 py-3 bg-white border border-gray-200 text-gray-600 font-bold rounded-xl hover:bg-gray-50 transition-all"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </ProductModal>
        )}

        {/* Edit Modal (Similar structure to Add) */}
        {openEditModal && (
          <ProductModal
            closeModal={setOpenEditModal}
            width="450px"
            title={"Update Category"}
          >
            <form onSubmit={handleSubmitEditCategory} className="p-2">
              <div className="space-y-4">
                <div>
                  <label className="block mb-2 text-xs font-bold text-gray-500 uppercase">
                    Category Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    defaultValue={categoryEditFormData?.name}
                    className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
                    onChange={handleEditProductChange}
                  />
                </div>
                <div>
                  <label className="block mb-2 text-xs font-bold text-gray-500 uppercase">
                    Description
                  </label>
                  <textarea
                    name="description"
                    rows="4"
                    defaultValue={categoryEditFormData?.description}
                    className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
                    onChange={handleEditProductChange}
                  ></textarea>
                </div>
                <div className="flex gap-3 pt-4 border-t border-gray-100">
                  <button
                    type="submit"
                    className="flex-1 py-3 bg-green-600 text-white font-bold rounded-xl hover:bg-green-700 shadow-md transition-all"
                  >
                    Update Changes
                  </button>
                  <button
                    type="button"
                    onClick={() => setOpenEditModal(false)}
                    className="flex-1 py-3 bg-white border border-gray-200 text-gray-600 font-bold rounded-xl"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </ProductModal>
        )}

        {/* Delete Prompt */}
        {openPromptModal && (
          <PromptModal
            width={"380px"}
            title={"Confirm Deletion"}
            closeModal={setPromptOpenModal}
          >
            <div className="p-6 text-center">
              <div className="w-20 h-20 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <RiDeleteBin2Line size={40} />
              </div>
              <h3 className="mb-2 text-xl font-bold text-gray-800">
                Delete Category?
              </h3>
              <p className="mb-6 text-sm text-gray-500">
                Are you sure you want to remove{" "}
                <span className="font-bold text-gray-700">
                  "{selectedEditData?.name}"
                </span>
                ? This action cannot be undone.
              </p>
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={() => {
                    DeleteCategory(selectedEditData?._id);
                    setPromptOpenModal(false);
                  }}
                  className="flex-1 py-3 bg-red-600 text-white font-bold rounded-xl hover:bg-red-700 transition-all"
                >
                  Yes, Delete
                </button>
                <button
                  onClick={() => setPromptOpenModal(false)}
                  className="flex-1 py-3 bg-gray-100 text-gray-600 font-bold rounded-xl hover:bg-gray-200 transition-all"
                >
                  Cancel
                </button>
              </div>
            </div>
          </PromptModal>
        )}

        <ToastContainer autoClose={3000} />
      </RenderHirePurchasePage>
    </div>
  );
}

export default ProductCategory;
